import {generateUuid} from '@/utils/uuid';
import {fullStoryService} from '../integrations/fullstory.service';
// import {getAnalytics, logEvent, setUserId, setUserProperties} from 'firebase/analytics';

// NOTE: We are using GTM dataLayer directly instead of Firebase Analytics to avoid conflicts with other GTM tracking.

const dataLayer = (window as any).dataLayer || {
  push: () => {
    /** noop */
  },
};

/*
 * List of build-in events:
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/events
 */

/**
 * Identify the user.
 */
export const setAnalyticsUserId = (userId: string) => {
  if (!userId) {
    return;
  }

  // Firebase Analytics
  // setUserId(analytics, userId);

  // GTM
  dataLayer.push({event: 'user_id', user_id: userId});

  // FullStory
  fullStoryService.identify(userId);
};

/**
 * Set user properties.
 */
export function setAnalyticsUserProperties(properties: Record<string, unknown>) {
  // GTM
  dataLayer.push({event: 'user_properties', ...properties});

  // FullStory
  fullStoryService.setUserProperties(properties);
}

/**
 * Log an analytics event.
 */
export function logAnalyticsEvent(eventName: string, eventParams?: any) {
  // Firebase Analytics
  // logEvent(analytics, eventName, eventParams);

  // GTM
  dataLayer.push({event: eventName, ...eventParams});

  // FullStory
  fullStoryService.logCustomEvent(eventName, eventParams);
}

/**
 * Log a login event.
 */
export function logLoginEvent(method?: string, otherParams?: {[key: string]: any}) {
  // Firebase Analytics
  // logEvent(analytics, 'login', { method: method, ...otherParams });

  // GTM
  dataLayer.push({event: 'login', method, ...otherParams});

  // FullStory
  if (otherParams?.userUid) {
    const {userUid, ...rest} = otherParams;
    fullStoryService.identify(userUid);
    fullStoryService.setUserProperties({
      method,
      ...rest,
    });
  }
}

/**
 * Log a logout event.
 */
export function logLogoutEvent() {
  logAnalyticsEvent('logout');

  // FullStory anonymize user
  fullStoryService.anonymizeUser();
}

/**
 * Log a sign up event.
 */
export function logSignUpEvent(method?: string, otherParams?: {[key: string]: any}) {
  // Firebase Analytics
  // logEvent(analytics, 'sign_up', { method: method, ...otherParams });

  // GTM
  dataLayer.push({event: 'sign_up', method, ...otherParams});

  // FullStory
  fullStoryService.logCustomEvent('sign_up', {method, ...otherParams});
}

/**
 * Log a share event.
 */
export function logShareEvent(eventParams: {method?: string; content_type?: string; item_id?: string}) {
  // Firebase Analytics
  // logEvent(analytics, 'share', eventParams);

  // GTM
  dataLayer.push({event: 'share', ...eventParams});

  // FullStory
  fullStoryService.logCustomEvent('share', eventParams);
}

/**
 * Log an event to track the user via a custom client ID.
 */
export function trackUserViaCustomClientId() {
  try {
    let clientTrackingId = localStorage.getItem('clientTrackingId');
    if (!clientTrackingId) {
      clientTrackingId = `${Date.now()}-${generateUuid()}`;
      localStorage.setItem('clientTrackingId', clientTrackingId);
    }

    // Firebase Analytics
    // setUserProperties(analytics, {client_tracking_id: clientTrackingId});

    // GTM
    dataLayer.push({event: 'user_properties', client_tracking_id: clientTrackingId});

    // FullStory
    fullStoryService.setUserProperties({client_tracking_id: clientTrackingId});
  } catch (err) {
    console.error('Failed to get/set tracking client ID', err);
  }
}
